
window.__babelfish = window.__babelfish || {};
window.__babelfish_plurals = window.__babelfish_plurals || {};

window.__babelfishReady = (function () {
  function fetchData() {
    const urlElem = document.getElementById('js-translations-source');
    const transUrl = urlElem ? urlElem.href : null;
    if (transUrl) {
      return fetch(transUrl, { cache: 'force-cache' }).then((response) => response.json());
    }
    return Promise.resolve({});
  }

  return fetchData()
    .then((jsonIn) => {
      const urlElem = document.getElementById('js-translations-source');
      const locale = urlElem?.dataset?.locale || urlElem?.getAttribute('data-locale') || 'it_IT';

      window.__mls_i18next = { locale, resources: jsonIn };

      function add(keys, value) {
        keys.split('|').forEach((key, i) => {
          window.__babelfish[key] = value;
          window.__babelfish_plurals[key] = i + 1;
        });
      }

      Object.keys(jsonIn).forEach((keys) => {
        add(keys, jsonIn[keys]);
      });
    })
    .catch((error) => {
      console.error('BabelfishLoaderWrapperPlugin: problems loading translations');
      console.error(error);
    })
    .finally(() => {
      window.dispatchEvent(new CustomEvent('BabelfishLoaderWrapperPlugin::mls::hashed/runtime::ready'));
    });
})();
